import { combineReducers } from 'redux';

import domainId from './domainId';
import filterByCustomer from './filterByCustomer';

const selected = combineReducers({
  domainId,
  filterByCustomer,
});

export default selected;
